
























import {computed, defineComponent, inject, PropType, ref} from '@vue/composition-api'
import {AutomationField, AutomationFieldModel, AutomationRecipeSection} from '@/types/automations'
import AutomationFieldSelect from '@/components/automation/sentence/field/AutomationFieldSelect.vue'
import {checkIsMatchedAutomationField} from '@/types/automations/utils'
import {getAutomationFieldLabel} from '@/components/automation/display-value'

export default defineComponent({
    name: 'AutomationSentenceFieldSlot',
    components: {AutomationFieldSelect},
    props: {
        field: {
            type: Object as PropType<AutomationField>,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        recipeSection: {
            type: String as PropType<AutomationRecipeSection>,
            required: true
        }
    },
    setup(props, {emit}) {
        const opened = ref(false)
        const fieldName = computed(() => props.field?.value)
        const fieldLabel = computed(() => getAutomationFieldLabel({
            field: props.field,
            objects: getAvailableObjects()
        }))

        const getAvailableObjects = inject('getAvailableObjects', () => []) as Function

        const onChange = (field: AutomationField) => {
            emit('change', field)
        }

        const isCondition = computed(() => props.recipeSection === AutomationRecipeSection.CONDITION)

        const fieldsSelectFilter = (field: AutomationFieldModel) => isCondition.value ? !checkIsMatchedAutomationField(field) : true

        return {
            opened,
            fieldName,
            fieldLabel,
            onChange,
            fieldsSelectFilter
        }
    }
})
